import MuiDialogContent from '@mui/material/DialogContent';

import { styled } from 'helpers';

import { Props } from './types';

export const DialogContent = styled(MuiDialogContent)<Props>`
  color: ${({ theme }) => theme.palette.blueGrey['A600']};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  padding: 0 32px;
`;

export default DialogContent;
